import * as React from 'react';
import { SelectSingle } from 'app/area/shared/translated-components';
import { ChangeOwnerFieldProps, ChangeOwnerField } from 'app/area/favourite-administration/list/change-owner/types';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { endpoints } from 'app/area/favourite-administration/form/endpoints';
import { FavouriteListIds } from 'app/area/favourite-administration/list/constants';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const Owner = (props: ChangeOwnerFieldProps) => {
  const { list: { changeOwner: { form, validation } = {} }, options, translation,
    loadOptions, updateByKey, resetValidation } = props;

  const fieldKey = ChangeOwnerField.fromOwners;
  const valueItem = form?.[fieldKey];

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(FavouriteListIds.fromOwners);
    updateByKey(fieldKey, value);
  };

  const onOwnerLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptions(FavouriteListIds.fromOwners, endpoints.ownerOptions, loadOptionsParams);
  };

  return <SelectSingle
      componentId={FavouriteListIds.fromOwners}
      className={'w-100'}
      valueItem={valueItem}
      label={{ text: translation.owner, visible: true, required: true }}
      options={options?.[FavouriteListIds.fromOwners]?.codes as ComplexValue<number>[] || []}
      placeholder={translation?.search}
      fetching={options?.[FavouriteListIds.fromOwners]?.fetching}
      onLoadOptions={onOwnerLoadOptions}
      onChange={onChange}
      validation={validation?.fromOwners} />;
};
